import { render, staticRenderFns } from "./CardMobileBasic.vue?vue&type=template&id=faf59956&scoped=true&"
import script from "./CardMobileBasic.vue?vue&type=script&lang=js&"
export * from "./CardMobileBasic.vue?vue&type=script&lang=js&"
import style0 from "./CardMobileBasic.vue?vue&type=style&index=0&id=faf59956&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf59956",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('faf59956')) {
      api.createRecord('faf59956', component.options)
    } else {
      api.reload('faf59956', component.options)
    }
    module.hot.accept("./CardMobileBasic.vue?vue&type=template&id=faf59956&scoped=true&", function () {
      api.rerender('faf59956', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/SelecaoAssinatura/components/mobile/CardMobileBasic.vue"
export default component.exports